import type { UserProps } from '@img-arena/consoles-api-dde'
import type { Column, Filter } from '@/components/table/base'
import { COLUMN_CELL_TYPE } from '@/components/table/base'

export const DDE_TABLE_COLUMNS: Column<UserProps>[] = [
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'userName',
    label: 'Username',
    sortAttribute: 'username'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'userId',
    label: 'Email',
    sortAttribute: 'email'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'role.roleName',
    label: 'Role',
    sortAttribute: 'role'
  },
  {
    type: COLUMN_CELL_TYPE.DATE,
    id: 'lastLogin',
    label: 'Last Active',
    sortAttribute: 'lastActive',
    dateFormat: 'dd-MM-yyyy HH:mm:ss'
  }
]

export const DDE_TABLE_FILTERS: Filter<UserProps>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'ft',
    placeholder: 'Search',
    filterOptions: (row, search) => {
      if (!search) return true
      const lowerCaseSearch = search.toLowerCase()
      const { userName, userId } = row
      return (
        userName.toLowerCase().includes(lowerCaseSearch) ||
        userId.toLowerCase().includes(lowerCaseSearch)
      )
    }
  }
]

export const CSV_HEADERS = [
  'Username',
  'Email',
  'Role',
  'Operator ID',
  'Operator Name',
  'Last Active'
]

export const formatCsvRow = (row: UserProps) => [
  row.userName ?? '',
  row.userId ?? '',
  row?.role?.roleName ?? 'Operator',
  row?.role?.operatorId?.toString() ?? '',
  row?.role?.operatorName ?? '',
  row.lastLogin ?? ''
]
